<template>
  <page-layout
    title="采购订单"
    class="p-PurchaseOrder"
  >
    <header class="c-tradingcenter-search-header clearfix">
      <div class="c-tradingcenter-search-header-fl">
        <znl-input
          :border="true"
          v-model="dataTime"
          :height="30"
          date-type="daterange"
          form-type="datepicker"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="true"
          class="header-marginleft"
          @change="dataTimeChange"
          ref="dateinput"
          title="下单时间:"
          title-width="60px"
        >
        </znl-input>

        <znl-input
          width="180px"
          :height="30"
          :border="true"
          placeholder="搜索订单编号"
          class="header-marginleft"
          :clearable="true"
          title="订单编号:"
          title-width="60px"
          v-model="OrderNo"
          @keydown.enter="seachHandler"
        >
        </znl-input>

        <znl-input
          width="180px"
          :height="30"
          :border="true"
          placeholder="订单状态"
          class="header-marginleft"
          :clearable="true"
          title="订单状态:"
          title-width="60px"
          v-model="Statuses"
          form-type="select"
          :select-options="selectOptions"
          @change="selectChange"
        >
        </znl-input>

        <znl-button
          :width="60"
          :height="30"
          style-type="main"
          class="header-marginleft"
          @click="seachHandler"
        >
          <i class="iconfont icon-sousuo"></i>
          搜索
        </znl-button>

        <znl-button
          :width="60"
          :height="30"
          class="header-marginleft"
          @click="clearParams"
        >
          <i class="iconfont icon-refresh"></i>
          重置
        </znl-button>
      </div>
    </header>

    <div>
      <grid
        v-loading="loading"
        element-loading-text="数据加载中.."
        :columns="columns"
        :datas="datas"
        ref="grid"
        :total-count="totalCount"
        :page-size="pageSize"
        :page-index="pageIndex"
        :on-page-changed="onBindData"
        domLayout="autoHeight"
      ></grid>
    </div>
  </page-layout>
</template>

<script>
import PageLayout from '../PageLayout';
import { httpPost } from '../../assets/scripts/http';
import { columns } from './columns';
export default {
  name: 'PurchaseOrder',
  components: {
    PageLayout
  },
  data() {
    return {
      dataTime: ['', ''],
      loading: false,
      datas: [],
      columns: columns,
      pageSize: 20,
      pageIndex: 1,
      totalCount: 1,
      OrderNo: '',
      Statuses: [],
      selectOptions: [
        { key: [], value: '全部' },
        { key: [1, 2, 6], value: '处理中' },
        { key: [3], value: '已发货' },
        { key: [4], value: '已完成' },
        { key: [5], value: '已取消' }
      ]
    };
  },
  created() {
    this.onBindData();
  },
  methods: {
    dataTimeChange(value) {
      this.dataTime = value ? value : ['', ''];
      this.onBindData();
    },
    selectChange(value) {
      this.Statuses = value.key;
      this.onBindData();
    },
    clearParams() {
      this.$refs.dateinput.clear();
      this.OrderNo = '';
      this.dataTime = ['', ''];
      this.Statuses = [];
      this.onBindData();
    },
    seachHandler() {
      this.onBindData();
    },
    onBindData(PageIndex = 1) {
      this.loading = true;
      this.dataTime = this.dataTime ? this.dataTime : ['', ''];
      httpPost('shareStock/getPurchaseOrderDetailsAsync', {
        OrderNo: this.OrderNo,
        Statuses: this.Statuses,
        StartCreateTime: this.dataTime[0],
        EndCreateTime: this.dataTime[1],
        PageIndex,
        PageSize: this.pageSize
      }).then(res => {
        this.loading = false;
        if (res.Code === 0) {
          const DATAS = res.Data.ResultList || [];
          DATAS.forEach(item => {
            item.RemarkOrderHistory = '';
            item.RemarkIsEdit = false;
            item.RemarkEditInputValue = '';
          });
          this.pageIndex = res.Data.PageIndex || 1;
          this.totalCount = res.Data.TotalCount || 1;
          DATAS.forEach((item, index) => (item.ID = index));
          this.datas = DATAS;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.p-PurchaseOrder {
  .header-marginleft {
    margin-left: 10px;
  }
  .el-table__empty-block {
    min-height: 400px;
  }
}
</style>
